interface policyListItem {
  productName: string;
  productNameTc: string;
  policyNumber: string;
  correspondenceAddressFlag: string; //Y 表示改過
  corrAddress1: string;
  corrAddress2: string;
  corrAddress3: string;
  corrAddress4: string;
  corrAddress5: string;
  corrAddressCountry: string;
}
interface selectPolicyList {
  insuredName?: string;
  policyNumber: string;
  productName?: string;
  productNameTc?: string;
  correspondenceAddressFlag?: string; //Y 表示改過
  corrAddress1?: string;
  corrAddress2?: string;
  corrAddress3?: string;
  corrAddress4?: string;
  corrAddress5?: string;
  corrAddressCountry?: string;
}
export const canShowTax = (list: policyListItem[], selectList: selectPolicyList[], area: string) => {
  const newSelectList = list.filter((item) => {
    return selectList.some((i) => i.policyNumber === item.policyNumber);
  });
  console.log('newSelectList++++++++++++++++++++++++++++++++++++++', newSelectList);
  if (newSelectList) {
    console.log(newSelectList.some((item) => item.corrAddressCountry !== area));

    return newSelectList.some((item) => item.corrAddressCountry !== area);
  }
};
